var ColorPicker = function (obj, options) {
    var self = this;
    this.options = options || {};

    if (!obj.length) obj = [obj];

    this.target = obj;
    this.canvases = {};
    this.colorMap = [];

    var drawSettings = {
        basicColors: [0xffffff, 0xff0000, 0xffff00, 0x00ff00, 0x00ffff, 0x0000ff, 0xff00ff, 0xffffff],
        steps: 9,
        stepsVertical: 60,
        stepWidth: 3,
    };

    this.options = $.extend(true, {}, this.options, drawSettings);

    this.forEach = function (f) {
        for (var i = 0; i < this.target.length; i++) f(this.target[i], i);
    };

    this.paintContent = function (ctx, i) {
        // composes a RGB object from r,g,b bytes or 0xRRGGBB integer
        var toRgb = function (r, g, b) {
            var isRGB = g !== undefined && b !== undefined;
            return {
                r: isRGB ? r : (r & 0xff0000) >> 16,
                g: isRGB ? g : (r & 0x00ff00) >> 8,
                b: isRGB ? b : r & 0x0000ff,
                toString: function () {
                    var c = (this.r << 16) | (this.g << 8) | this.b;
                    var s = c.toString(16);
                    while (s.length < 6) s = '0' + s;
                    return s;
                },
            };
        };

        var calculateStep = function (c1, c2, steps) {
            if (steps === undefined) steps = self.options.steps;

            diffs = {
                r: (c2.r - c1.r) / steps,
                g: (c2.g - c1.g) / steps,
                b: (c2.b - c1.b) / steps,
            };

            return diffs;
        };

        var addColor = function (color, toAdd, max) {
            var add = function (src, step, maxPart) {
                var sgn = Math.sign(step);
                src = src + step;
                var tmp = (src - maxPart) * sgn;
                if (tmp > 0) return maxPart;
                return src;
            };

            return toRgb(add(color.r, toAdd.r, max.r), add(color.g, toAdd.g, max.g), add(color.b, toAdd.b, max.b));
        };

        var x = 0;
        var y = 0;
        var color0 = toRgb(0);

        // create RGB objects and calculate steps (from the basic color to black at the bottom)
        var basis = [];
        var basisSteps = [];
        for (var i = 0; i < self.options.basicColors.length; i++) {
            basis[i] = toRgb(self.options.basicColors[i]);
            basisSteps[i] = calculateStep(basis[i], color0, self.options.stepsVertical);
        }

        var cellX = 0;
        for (var k = 0; k < self.options.stepsVertical; k++) {
            // single row
            for (var i = 0; i < basis.length - 1; i++) {
                var color1 = basis[i];
                var color2 = basis[i + 1];
                // difference between neighbor (horizontal) basic colors
                var colorStep = calculateStep(color1, color2);
                color = basis[i];
                // all colors between two adjacent basic colors
                for (var j = 0; j <= self.options.steps; j++) {
                    if (self.colorMap[k] === undefined) self.colorMap[k] = [];

                    // fill style will be saved
                    var clr = color.toString();
                    ctx.fillStyle = '#' + clr;
                    self.colorMap[k][cellX] = ctx.fillStyle;
                    // rect
                    ctx.fillRect(x, y, self.options.stepWidth, self.options.stepWidth);
                    // next color, next position in the grid, next cell
                    color = addColor(color, colorStep, color2);
                    x = x + self.options.stepWidth;
                    cellX++;
                }
            }

            y = y + self.options.stepWidth;
            x = 0;
            cellX = 0;

            for (var l = 0; l < basis.length; l++) {
                basis[l] = addColor(basis[l], basisSteps[l], color0);
            }
        }
    };

    this.createDiv = function (obj, i) {
        if (!this.template) {
            this.template = require('utils/templates/colorpicker');
        }

        var templateData = {
            id: 'canvas-' + i,

            width: (self.options.steps + 1) * self.options.stepWidth * (self.options.basicColors.length - 1),
            height: (self.options.stepsVertical - 1) * self.options.stepWidth,

            wrapperClass: self.options.wrapperClass,
        };

        var html = this.template(templateData);
        if (self.options.owner) {
            $(self.options.owner).html(html);
        } else {
            $(obj).after(html);
        }

        self.canvases[i] = {};
        self.canvases[i] = $('#canvas-' + i)[0];

        var cnv = self.canvases[i];
        var ctx = cnv.getContext('2d');
        self.paintContent(ctx, i);

        var cnv = self.canvases[i];
        $(cnv).on('mousedown', self.canvasMouseDown);
        $(cnv).on('mousemove', function (e) {
            if (e.buttons & 1) self.canvasMouseDown(e);
        });
        $(cnv).on('touchmove', function (e) {
            self.canvasMouseDown({
                which: 1,
                pageX: e.originalEvent.touches[0].pageX,
                pageY: e.originalEvent.touches[0].pageY,
                target: e.target,
            });
        });
    };

    this.canvasMouseDown = function (e) {
        if (e.preventDefault) {
            e.preventDefault();
            e.stopPropagation();
        }

        var cnv = $(e.target).parent().find('canvas')[0];
        var ctx = cnv.getContext('2d');

        var relx = $(cnv).offset().left;
        var rely = $(cnv).offset().top;

        var idxY = Math.floor((e.pageY - rely) / drawSettings.stepWidth);
        var idxX = Math.floor((e.pageX - relx) / drawSettings.stepWidth);

        if (self.colorMap[idxY] && self.colorMap[idxY][idxX]) {
            var selectedColor = self.colorMap[idxY][idxX];
            if (selectedColor && self.target) {
                for (var i = 0; i < self.target.length; self++) {
                    if (self.canvases[i] == cnv) {
                        $(self.target).css('background-color', selectedColor);
                        if (self.options.onSelection) {
                            self.options.onSelection(selectedColor);
                        }
                        break;
                    }
                }
            }
        }

        return false;
    };

    this.forEach(this.createDiv);
};

module.exports = ColorPicker;
